import { LitElement, html } from 'lit';
import styles from './styles';
/**
 * @slot - The element's content.
 *
 * @csspart base - The element's base container.
 */
export default class AmityekoTgBodyTwo extends LitElement {
    render() {
        return html `<p part="base"><slot></slot></p>`;
    }
}
AmityekoTgBodyTwo.styles = styles;
if (!customElements.get('amityeko-tg-body-two')) {
    customElements.define('amityeko-tg-body-two', AmityekoTgBodyTwo);
}
//# sourceMappingURL=index.js.map